// @ts-nocheck
import { StackRow, Text } from "@smoothie-framework/ui";

const steps = [
  "UPLOAD STORY",
  "GENERATE 80-EPISODE SCRIPT",
  "BUILD AI STORYBOARD",
  "RENDER & PUBLISH SERIES",
] as const;

function PipelineSequence() {
  return (
    <StackRow as="span" className="pipeline-sequence"gap={3} pr={5}>
      {steps.map((step) => (
        <StackRow as="span" className="pipeline-item" gap={5} key={step}>
          <Text as="span" textStyle="meta" color="subtle">
            {step}
          </Text>
          <Text
            as="span"
            aria-hidden="true"
            className="pipeline-arrow"
            textStyle="meta"
            color="accent"
          >
            →
          </Text>
        </StackRow>
      ))}
    </StackRow>
  );
}

export function Pipeline() {
  return (
    <StackRow
      as="nav"
      className="pipeline"
      background="background"
      aria-label="Four step pipeline"
      minH={10}
      borderTopWidth="sm"
      borderTopStyle="solid"
      borderTopColor="borderSubtle"
      borderBottomWidth="sm"
      borderBottomStyle="solid"
      borderBottomColor="borderSubtle"
    >
      <StackRow as="span" className="pipeline-track" aria-hidden="true" w="max">
        {Array.from({ length: 8 }, (_, index) => (
          <PipelineSequence key={index} />
        ))}
      </StackRow>
    </StackRow>
  );
}
